var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import createSvgSpritesheetContainer from '../../utils/createSvgSpritesheetContainer';
var STYLE_NAMESPACE = 'vcp-icon';
var Icon = function (_a) {
    var name = _a.name, _b = _a.size, size = _b === void 0 ? 'medium' : _b, className = _a.className, svgElementProps = __rest(_a, ["name", "size", "className"]);
    React.useEffect(function () {
        var container = createSvgSpritesheetContainer();
        if (!container) {
            return;
        }
        import('./spritesheet/spritesheet-svg')
            .then(function (r) { return r.default; })
            .then(function (result) {
            container.innerHTML = result;
        });
    }, []);
    return (React.createElement("svg", __assign({ className: classNames(STYLE_NAMESPACE, "".concat(STYLE_NAMESPACE, "-").concat(size), className) }, svgElementProps),
        React.createElement("use", { className: "".concat(STYLE_NAMESPACE, "-use"), xlinkHref: "#vcp-spritesheet-icon-".concat(name) })));
};
export default Icon;
